import { render, staticRenderFns } from "./TagCell.vue?vue&type=template&id=4885cbd0&scoped=true&"
import script from "./TagCell.vue?vue&type=script&lang=js&"
export * from "./TagCell.vue?vue&type=script&lang=js&"
import style0 from "./TagCell.vue?vue&type=style&index=0&id=4885cbd0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4885cbd0",
  null
  
)

export default component.exports